<svelte:options tag="winners-component-final"/>
<script>
	import { onMount } from "svelte";
	import Filter from "./Components/Filter.svelte";
	import List from "./Components/List.svelte";
	import { applyFilter } from './Components/search'
	import Banner from './Components/Banner.svelte';

	const urlParams = new URLSearchParams(window.location.search);
	const isY = urlParams.has('y') || window.location.pathname.split('/')[2] != undefined;

	let nominations = [];
	let filtered = [];

	let loaded = false;
	let awards = [];
	let categories = [];
	let countries = [];
	let agencies = [];
	let medals = ["Gran Sol", "Mención Especial", "Oro", "Plata", "Bronce"];
	let myData = [];
	let filter = { categories, countries, medals, agencies, medals };
	let year = '';
	let availableYears = [];

	const removeAccents = (string) => {
		return string
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "");
	};

	const handleSearch = (e) => {
		const params = e.detail;

		filtered = applyFilter(nominations, params);
		if (params.anio && myData[params.anio] != undefined) {
			categories = myData[params.anio].categories || [];
			categories = [categories[3], categories[0], categories[1], categories[2]];
			countries = myData[params.anio].countries || [];
			agencies = myData[params.anio].agencies || [];
			filter = { categories, countries, medals, agencies };
		}
	};

	onMount(async function () {
    	const gYear = urlParams.get('y');

	// Obtener años disponibles desde el API
	const yearsResponse = await fetch(
		process.env === 'production'?"https://admin.produfiap.com/awards/winnersyears":"http://localhost:3000/awards/winnersyears"
	);
	const yearsData = await yearsResponse.json();
	availableYears = yearsData.years || ['2024', '2023', '2022'];

	const response = await fetch(
		process.env === 'production'?"https://admin.produfiap.com/nominations/getwinnersall":"http://localhost:3000/nominations/getwinnersall"
	);
	const data = await response.json();
	
	// Usar el primer año disponible como default (el más reciente)
	const defaultYear = availableYears[0] || '2024';
	year = (gYear && data[gYear]) ? gYear : defaultYear;

		myData = data;

		loaded = true;

		nominations = data;
		categories = data[year].categories || [];
		countries = data[year].countries || [];
		agencies = data[year].agencies || [];

		categories = [categories[3], categories[0], categories[1], categories[2]];
		filtered = nominations[year].nominations || [];
		filter = { categories, countries, medals, agencies };
	});
	const loading = process.env === 'production'?`${myurl}/images/loading.gif`:"./images/loading.gif";
</script>

<main>
	{#if !filtered}
		<div class="row">
			<div class="col-sm-12 text-center"><img class="loading" src={loading} alt="loading..."></div>
		</div>
	{:else}
		<div class="section-cards-fiap">
			<div class="container">
				<Banner bannerId="75908" />
				<Filter {filter} {loaded} on:search={handleSearch} year={year} {availableYears} />
				<div class="row">
					<List nominations="{filtered}" {loaded}></List>
				</div>
			</div>
		</div>
	{/if}
</main>

<style>
	/* ========================================================================
	   CSS IMPORTS - IMPORTANTE: Leer antes de hacer cambios
	   ========================================================================
	   
	   DESARROLLO STANDALONE (localhost:3050):
	   Las rutas actuales funcionan para desarrollo del componente.
	   
	   INTEGRACIÓN EN APP PRINCIPAL (localhost:8083/ganadores):
	   Para que funcione integrado, cambiar los @import por estas rutas:
	   
	   @import "../assets/js/winners-components/list/css/bootstrap.min.css";
	   @import "../assets/js/winners-components/list/css/fiap.css";
	   @import "../assets/js/winners-components/list/css/global.css";
	   
	   ======================================================================== */
	
	/* Rutas actuales (STANDALONE): */
	/* @import "/css/bootstrap.min.css";
	@import "/css/fiap.css";
	@import "/css/global.css"; */
	/* Rutas para integración en app principal: */
	@import "../assets/js/winners-components/list/css/bootstrap.min.css";
	@import "../assets/js/winners-components/list/css/fiap.css";
	@import "../assets/js/winners-components/list/css/global.css";

	main {
		color: #333;
		box-sizing: border-box;
	    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
        font-size: 14px;
	}

	img.loading {
		width: 200px;
	}
</style>